<template>
    <v-container class="settings-container">
        <Loader ref="Loader"></Loader>
        <SuccessModal ref="SuccessModal"></SuccessModal>
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <v-layout>
            <v-flex xs4 md1 sm4 lg12xl12>
                <v-avatar slot="offset" class="mx-auto d-block" size="130">
                    <v-img @click="addFile" v-model="form.CompanyLogo" @mouseover="imageHover" @mouseout="imageHoverDone"
                        :class="{ 'image-overlay': showOverlay }" style="width: 100%; border-radius: 50%;" :src="newImage"
                        aspect-ratio="1" class="grey lighten-2">

                    </v-img>
                </v-avatar>
                <br>
                <v-card-text class="text-xs-center">
                    <h4 class="card-title font-weight-light">{{ form.CompanyName }}, {{ form.CountryCode }}</h4>
                </v-card-text>
            </v-flex>
            <v-flex xs6>
                <v-form @submit.prevent="SubmitForm">
                    <v-container>
                        <v-layout wrap>
                            <v-flex xs12 md12>
                                <h3 style="font-size: 2em;">{{ TranslateText("Account Details")}}</h3>
                            </v-flex>
                            <v-flex xs12 md12>
                                <v-text-field :label="TranslateText('Company Name')" v-model="form.CompanyName" />
                            </v-flex>
                            <v-flex xs12 md12>
                                <v-text-field :label="TranslateText('Email Address')" v-model="form.EmailAddress" />
                            </v-flex>
                            <v-flex xs12 md12>
                                <v-text-field :label="TranslateText('Contact Telephone Number')" v-model="form.PhoneNumber" />
                            </v-flex>
                            <v-flex xs12 md12>
                                <v-text-field :label="TranslateText('Address')" v-model="form.StreetAddress" />
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-text-field :label="TranslateText('City')" v-model="form.City" />
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-combobox :label="TranslateText('Country Code')" v-model="form.CountryCode" :items="Countries" />
                            </v-flex>

                            <v-flex xs12 text-xs-right>
                                <br>
                                <v-btn color="primary" type="submit">
                                    {{TranslateText("Update")}}
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <input @change="readURL" style="display: none" ref="fileInput" type="file">
                    </v-container>
                </v-form>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    // import axios from "axios";
    import JWT from 'jsonwebtoken'
    const countryList = require('country-list');

    export default {
        data: () => ({
            form: {
                ID: null,
                CompanyName: null,
                CompanyLogo: "",
                EmailAddress: null,
                PhoneNumber: null,
                StreetAddress: null,
                City: null,
                CountryCode: null
            },
            CountryName: null,
            Countries: null,
            showOverlay: false,
            file: null,
            newImage: ""
        }),
        mounted() {
            let self = this;

            self.FetchData();
            self.getCountries();

        },
        methods: {
            FetchData() {
                let self = this;
                let AccountID = JWT.decode(sessionStorage['accessToken']).ACCOUNT_ID;

                self.$refs.Loader.show();
                self.get("/Account?id=" + AccountID)
                    .then(response => {
                        self.$refs.Loader.hide();
                        console.log(response)
                        // setting the data
                        self.form.ID = response.data.ID;
                        self.form.CompanyName = response.data.CompanyName;
                        self.newImage = 'data:image/png;base64,' + response.data.CompanyLogo;
                        self.form.EmailAddress = response.data.EmailAddress;
                        self.form.PhoneNumber = response.data.PhoneNumber;
                        self.form.StreetAddress = response.data.StreetAddress;
                        self.form.City = response.data.City;
                        self.form.CountryCode = response.data.CountryCode;
                    })

                console.log(self.form.CompanyLogo)

            },
            SubmitForm() {
                let self = this;
                var Request = self.form;
                // self.form.CountryCode = countryList.getCode(self.form.CountryCode);
                let AccountID = JWT.decode(sessionStorage['accessToken']).ACCOUNT_ID;
                // self.form.CompanyLogo = null;
                self.$refs.Loader.show();
                self.put("/Account?id=" + AccountID, Request) // change url & 1 accordingly - 1 is account ID
                    .then(res => {
                        self.$refs.Loader.hide();
                        console.log(res)
                        self.$refs.SuccessModal.show(); // success modal
                        self.$refs.SuccessModal.setText("Updated account details!");

                        setTimeout(function () {
                            self.$refs.SuccessModal.hide();
                        }, 1000)
                    })
                    .catch(error => {
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText(error.toString());
                    })
            },

            getCountries() {
                let self = this;

                self.Countries = countryList.getCodes();
            },
            imageHover() {
                let self = this;
                self.showOverlay = true;
            },
            imageHoverDone() {
                let self = this;
                self.showOverlay = false;
            },
            addFile() {
                let self = this;
                self.$refs.fileInput.click();
            },
            readURL(e) {
                let self = this;
                self.blobToDataURL(e.target.files[0], function (dataurl) {
                    self.newImage = dataurl;
                    self.blobToArrayBuffer(e.target.files[0], function (result) {
                        self.form.CompanyLogo = Array.from(new Uint8Array(
                            result));
                        console.log(self.form.CompanyLogo)
                    });

                })
            },
            blobToArrayBuffer(blob, callback) {
                var a = new FileReader();
                a.onload = function (e) {
                    callback(a.result);
                }
                a.readAsArrayBuffer(blob);
            },
            blobToDataURL(blob, callback) {
                var a = new FileReader();
                a.onload = function (e) {
                    callback(e.target.result);
                }
                a.readAsDataURL(blob);
            }
        }
    }
</script>

<style scoped>
    .settings-container {
        margin-top: 1%;
    }

    .image-overlay {
        cursor: pointer;
        opacity: 0.1;
    }
</style>